import React, {Component} from 'react';
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import I18n from 'lib/i18n/i18n';
import WorthyApi from "lib/api/worthyApi";
import UserActions from "lib/userActions";
import {dollarsWithoutCents} from 'helpers/ApplicationHelper';
import {siteItemPage, getAuctionChanceOfSuccess} from 'helpers/itemHelper';
import PopupTooltipSuccessFee from "components/popups/popupTooltipSuccessFee";
import {PopupSimilarItems} from 'components/popups/popupSimilarItems';
import {InputRadio, InputNumber} from "components/formElements";
import {hideLoader, showLoader} from 'actions/loader';
import GA from "lib/ga";

const ErrorTypes = Object.freeze({
    noReserve: 0,
    highReserve: 1
});

class UpdateReservePrice extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.hasError = false;
        this.onRadioBtnChange = this.onRadioBtnChange.bind(this);
        this.onCustomReservePriceChanged = this.onCustomReservePriceChanged.bind(this);
        this.updateReservePrice = this.updateReservePrice.bind(this);
        this.eventDelay = null;
    }

    componentDidMount() {
        UserActions.updateReservePrice('Update Reserve Price page presented');
    }

    get recommendedReservePrice() {
        return Math.floor(this.props.item.recommended_minimum_reserve_price);
    }

    get reservePriceDollars() {
        return dollarsWithoutCents(this.props.item.reserve_price);
    }

    get recommendedReservePriceDollars() {
        return dollarsWithoutCents(this.recommendedReservePrice);
    }

    get newReservePrice() {
        const selectedOptionValue = document.querySelector('#update-reserve-price input[type="radio"]:checked').value;
        if (selectedOptionValue === this.customOptionValue) {
            return parseInt(document.querySelector('#update-reserve-price input[type="number"]').value);
        } else
            return parseInt(selectedOptionValue) / 100 * this.recommendedReservePrice;
    }

    get radioOptions() {
        if (this._radioOptions) return this._radioOptions;
        let options = {},
            optionsJson = I18n.getVar('itemPage::updateReservePrice::radioOptions'),
            item = this.props.item;

        for (let key in optionsJson) {
            let lines = [],
                price = parseInt(key) / 100 * this.recommendedReservePrice;

            if (price >= item.reserve_price) break;

            for (let lineKey in optionsJson[key]) {
                let text,
                    isGuaranteedOrHighChange = '';

                if(key === '100'){
                    lineKey = lineKey === 'guaranteed' ? '0' : '1';
                    isGuaranteedOrHighChange = item.item_type_name.toLowerCase().includes('watch') || item.estimation.evaluation_after_grading > item.price_guarantee_const ? 'highestChance::' : 'guaranteed::';
                }

                if (lineKey === '0' && key !== Object.keys(optionsJson)[Object.keys(optionsJson).length - 1]) {
                    text = I18n.getJsx(`itemPage::updateReservePrice::radioOptions::${key}::${isGuaranteedOrHighChange}${lineKey}`, {
                        price: <span className='bolder'>{dollarsWithoutCents(price)}</span>
                    });
                } else {
                    text = I18n.getString(`itemPage::updateReservePrice::radioOptions::${key}::${isGuaranteedOrHighChange}${lineKey}`, {
                        recommended_reserve_price: this.recommendedReservePriceDollars
                    });
                }
                lines.push(lineKey === '0' ?
                    <span key={lineKey}>{text}</span> : <div key={lineKey}>{text}</div>
                );
            }
            options[key] = <div>{lines}</div>;
        }
        return this._radioOptions = options;
    }

    get customOptionValue() {
        return Object.keys(this.radioOptions)[Object.keys(this.radioOptions).length - 1];
    }

    onRadioBtnChange(value) {
        const collapsibleElm = document.querySelector('.collapsible');
        if (value === this.customOptionValue) {
            collapsibleElm.style.setProperty('max-height', collapsibleElm.scrollHeight + 'px');
            UserActions.updateReservePrice('Reserve price option 4 selected - Other reserve price');
        }
        else {
            collapsibleElm.style.setProperty('max-height', '0px');
            const optNumber = Object.keys(this.radioOptions).indexOf(value) + 1;
            const selectedPrice = Math.floor((parseInt(value) / 100 * this.recommendedReservePrice) * 100) / 100;
            GA.updateReserveSelect({
                current: selectedPrice,
                old: this.props.item.reserve_price,
                recommended: this.recommendedReservePrice,
                fieldName: 'itemId',
                fieldValue: this.props.item.id
            })
            UserActions.updateReservePrice(`Reserve price option ${optNumber} selected - ${optNumber === 1 ? 'Price guarantee' : 'Reserve price'} of ${selectedPrice}`);
        }
    }

    onCustomReservePriceChanged(e) {
        let value = parseInt(e.target.value),
            additionalTextElm = document.querySelector('.additional-text'),
            newAdditionalText;
        this.refs['custom-reserve-price'].setValue(value);
        this.clearErrors();

        // GA event
        if (this.eventDelay) clearTimeout(this.eventDelay);
        if (!value) {
            newAdditionalText = `${this.recommendedReservePriceDollars} Recommended`;
            additionalTextElm.style.color = '';
        }
        else {
            this.eventDelay = setTimeout(() => {
                GA.updateReserveInput({
                    current: value,
                    old: this.props.item.reserve_price,
                    recommended: this.recommendedReservePrice,
                    fieldName: 'itemId',
                    fieldValue: this.props.item.id
                });
            }, 1000);
            const chanceOfSuccess = getAuctionChanceOfSuccess(value, this.recommendedReservePrice),
                textColor = chanceOfSuccess === 100 ? '#128801' : '#FF0000';
            newAdditionalText = `${chanceOfSuccess}% chance of success`;
            additionalTextElm.style.color = textColor;
        }
        if (newAdditionalText !== additionalTextElm.innerHTML) {
            additionalTextElm.innerHTML = newAdditionalText;
        }
    }

    updateReservePrice() {
        if (!this.newReservePrice) this.setError(ErrorTypes.noReserve);
        else if (this.newReservePrice >= this.props.item.reserve_price)
            return this.refs['radio-reserve-price'].state.value === this.customOptionValue && this.setError(ErrorTypes.highReserve);
        else {
            let value = document.querySelector('#update-reserve-price input[type="radio"]:checked').value;

            if(this.customOptionValue === value) UserActions.updateReservePrice('Update Reserve CTA on update reserve price page clicked - option 4');
            else{
                const optNumber = Object.keys(this.radioOptions).indexOf(value) + 1;
                UserActions.updateReservePrice(`Update Reserve CTA on update reserve price page clicked - option ${optNumber}`);
            }

            GA.updateReserveSubmit({
                fieldName: 'itemId',
                fieldValue: this.props.item.id,
            });

            this.props.showLoader();
            WorthyApi.updateReservePrice(this.props.item.id, this.newReservePrice).then(() => {
                window.location = `${siteItemPage(this.props.item.id)}`;
            }).finally(() => {
                this.props.hideLoader();
            });
        }
    }

    setError(errorType) {
        const collapsibleElm = document.querySelector('#update-reserve-price .collapsible'),
            errorsElm = document.querySelector('#update-reserve-price .input-type-number .errors'),
            replacements = {};
        if (errorType == ErrorTypes.highReserve) replacements.price = this.reservePriceDollars;
        this.refs['custom-reserve-price'].setError(I18n.getString(`itemPage::updateReservePrice::errors::${errorType}`, replacements), () => {
            this.hasError = true;
            collapsibleElm.style.setProperty('max-height',
            parseInt(collapsibleElm.style.getPropertyValue('max-height')) + errorsElm.scrollHeight + 'px');
        });
    }

    clearErrors() {
        if (!this.hasError) return;
        this.hasError = false;
        const collapsibleElm = document.querySelector('#update-reserve-price .collapsible'),
            errorsElm = document.querySelector('#update-reserve-price .input-type-number .errors');
        collapsibleElm.style.setProperty('max-height',
            parseInt(collapsibleElm.style.getPropertyValue('max-height')) - errorsElm.scrollHeight + 'px');
        setTimeout(() => this.refs['custom-reserve-price'].clearErrors(), 700);
    }

    getMinSoldFor(){
        let similarItemsArr = this.props.item.similar_items;
        return similarItemsArr.reduce((min, similarItem) => similarItem.sold_for < min ? similarItem.sold_for : min, similarItemsArr[0].sold_for);
    }

    getMaxSoldFor(){
        let similarItemsArr = this.props.item.similar_items;
        return similarItemsArr.reduce((max, similarItem) => similarItem.sold_for > max ? similarItem.sold_for : max, similarItemsArr[0].sold_for);
    }

    render() {
        return (
            <div id='update-reserve-price'>
                <a className='back-caret orange' href={siteItemPage(this.props.item.id)} onClick={() => {
                    UserActions.updateReservePrice("'Back to auction' link clicked");
                }}>{I18n.getString('itemPage::updateReservePrice::backLinkText')}</a>
                { this.props.item.similar_items.length > 1 ? (<div className='orange-banner'>
                    {this.renderSimilarItemsLine()}
                </div>) : <noscript></noscript> }
                <h3>UPDATE RESERVE PRICE</h3>
                <div>Select a new reserve price below:</div>
                <InputRadio options={this.radioOptions} ref='radio-reserve-price' defaultValue={Object.keys(this.radioOptions)[0]} name="reserve-price" onAfterChange={this.onRadioBtnChange}/>
                <div className='collapsible'>
                    <span className='additional-text'>{`${this.recommendedReservePriceDollars} Recommended`}</span>
                    <InputNumber ref="custom-reserve-price" name="custom-reserve-price" inputId='custom-reserve-price' inputProps={{
                        required: false,
                        autoFocus: false,
                        id: 'custom-reserve-price',
                        min: 0,
                        onChange: this.onCustomReservePriceChanged
                    }}/>
                </div>
                <div className='button-container'>
                    <button className='btn btn-orange' onClick={this.updateReservePrice}>UPDATE RESERVE</button>
                    <span className='success-fees-line'>{this.renderSuccessFeesLine()}</span>
                </div>
            </div>
        );
    }

    renderSuccessFeesLine() {
        const linkText = I18n.getString('itemPage::updateReservePrice::successFees::linkText');
        return I18n.getJsx('itemPage::updateReservePrice::successFees::fullText', {
            linkText:
                <a className='orange' onClick={() => {
                    UserActions.updateReservePrice("'Worthy success fees apply' link on update reserve page clicked");
                    PopupTooltipSuccessFee.initPopup({
                        page: 'update_reserve_price',
                        openEvent: "'Worthy success fees' popup presented",
                        closeEvent: "'Worthy success fees' popup closed"
                    })
                }}>
                    {linkText}
                </a>
        });
    }

    renderSimilarItemsLine() {
        const linkText = I18n.getString('itemPage::updateReservePrice::similarItems::linkText'),
            item = this.props.item;
        return (
            I18n.getJsx('itemPage::updateReservePrice::similarItems::fullText', {
                linkText:
                    <a className='link orange' onClick={() => {
                        UserActions.updateReservePrice("'Similar items' link on update reserve price page clicked");
                        PopupSimilarItems.initPopup({
                            item: item,
                            auction_done: false,
                            onOpen: () => { UserActions.updateReservePrice("'Similar items' popup presented") },
                            onClose: () => { UserActions.updateReservePrice("'Similar items' popup closed") }
                        });
                    }}>
                        {linkText}
                    </a>,
                valueRange: <span>{`${dollarsWithoutCents(this.getMinSoldFor())} - ${dollarsWithoutCents(this.getMaxSoldFor())}`}</span>
            })
        );
    }
}

UpdateReservePrice.propTypes = {
    item: PropTypes.object.isRequired
};

UpdateReservePrice.defaultProps = {
    item: null
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({showLoader, hideLoader}, dispatch);
};

export default connect(null, mapDispatchToProps)(UpdateReservePrice);